import { auth, functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export const TriggerFetchLatestDocForEmbed = async ({ reportStage, clinicianId, patientId }) => {
  const fetchLatestDocumentForEmbed = httpsCallable(functions, 'fetchLatestDocumentForEmbed'); 

  const user = auth.currentUser;
  if (!user || !user.uid) {
    return { 
      success: false, 
      error: "User not authenticated" 
    };
  }

  try {
    const result = await fetchLatestDocumentForEmbed({
      report_stage: reportStage,
      clinician_id: clinicianId,
      patient_id: patientId
    });    

    // Check if the operation was successful
    if (result.data.status !== "success") {
      return { 
        success: false, 
        error: result.data.message || "Unknown error occurred" 
      };
    }

    // Return the embed URL and related metadata
    return { 
      success: true,
      embedUrl: result.data.embedUrl,
      title: result.data.title,
      expiresAt: result.data.expiresAt,
      reportType: result.data.reportType,
      lastGenerated: result.data.lastGenerated
    };

  } catch (error) {
    console.error('Error fetching document for embed:', error);
    return { 
      success: false, 
      error: error.message || "Failed to retrieve document for embedding" 
    };
  }
};